<template>
    <f7-page name='custom-page' :stacked="true">
        <bc-navbar></bc-navbar>
        <div id="pages_maincontent">
          <div class='custom-page'>
            <div class='custom-page-title'>
                {{customPage.title}}
            </div>                
            <div class='custom-page-content' v-html="customPage.body"></div>
          </div>            
        </div>   
    </f7-page>    

</template>
<script>
 import { mapState, mapActions } from 'vuex'

export default {
   name: 'custom-page',
   mounted: function () {
     this.loadCustomPage(this.pageId).then(function () {
       if (this.customPage == null) {
         this.$f7.mainView.router.load({url: 'home'})
       }
     }.bind(this))
   },
   updated: function () {
     var parentElem = document.getElementsByClassName('custom-page-content')
     console.log(parentElem)
     var anchors = parentElem[0].getElementsByTagName('a')
     for (var i = 0; i < anchors.length; i++) {
       var elem = anchors[i]
       elem.onclick = function () {
         var link = elem.getAttribute('href')
         var win = window.open(link, '_blank')
         win.focus()
       }
     }
   },
   computed: {
     ...mapState({
       customPage: state => state.customPage.page
     }),
     UpdateAnchors () {
 
     }
   },
   methods: {
     ...mapActions('customPage', [
       'loadCustomPage'
     ])
   },
   data () {
     return {
       pageId: this.$route.params.id
     }
   }
}
</script>
<style scoped>
.custom-page{
  padding: 25px;  
}
.custom-page-title{
  text-align: center;
  padding-bottom: 25px;
  font-weight: bold !important;
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// custom-page.vue?32b63bb3